import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Layout from "../../CommonComponents/Layout/Layout";
import AppContext from "../../../context/AppContext";
import { SIDER_TABS } from "../../../utils/Constants";

import LiveSports from "./LiveSports/LiveSports";
import EventMarkets from "./EventMarkets/EventMarkets";
import AllSports from "./AllSports/AllSports";
import LiveEvent from "./LiveEvent/LiveEvent";
import Shortcuts from "./Shortcuts/Shortcuts";
import TopLeagues from "./TopLeagues/TopLeagues";

import "./stylesSportsbookFM.css";
import './Shortcuts/stylesShortcuts.css';
import '../../WhiteList/AddNewIpPopup/stylesAddNewIpPopup.css';

function SportsbookFM() {
  const { setActiveSidebarTab } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.CONFIGURATIONS, "Sportsbook FM");

    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");

    if (tabParam) {
      const normalizedTab = tabParam
          .replace(/-/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase());

      setActiveTab(normalizedTab);
    } else {
      setActiveTab("Live Sports");
    }
  }, [location.search, setActiveSidebarTab]);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);

    const tabParam = tabName.toLowerCase().replace(/\s+/g, "-");
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", tabParam);
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  return (
    <Layout name={SIDER_TABS.CASINO}>
      <div className="location-restrictions-table-container">
        <div className="location-restrictions-table">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Sportsbook Feature Management</p>
              </div>
            </div>
            <div className="dashboard-tabs">
               <button
                className={activeTab === "Live Sports" ? "active" : null}
                onClick={() => setActiveTab("Live Sports")}
              >
                Live Sports
              </button>
               <button
                className={activeTab === "Event Markets" ? "active" : null}
                onClick={() => setActiveTab("Event Markets")}
              >
                Event Markets
              </button>
               <button
                className={activeTab === "All Sports" ? "active" : null}
                onClick={() => setActiveTab("All Sports")}
              >
                All Sports
              </button>
              <button
                  className={activeTab === "Live" ? "active" : null}
                  onClick={() => handleTabChange("Live")}
              >
                Live
              </button>
              <button
                  className={activeTab === "Shortcuts" ? "active" : null}
                  onClick={() => handleTabChange("Shortcuts")}
              >
                Shortcuts
              </button>
              <button
                  className={activeTab === "Top Leagues" ? "active" : null}
                  onClick={() => handleTabChange("Top Leagues")}
              >
                Top Leagues
              </button>
            </div>
            <div className="tab-content-sportsbook-fm ">
              {activeTab === "Live Sports" && <LiveSports />}
              {activeTab === "Event Markets" && <EventMarkets />}
              {activeTab === "All Sports" && <AllSports />}
              {activeTab === "Live" && <LiveEvent />}
              {activeTab === "Shortcuts" && <Shortcuts />}
              {activeTab === "Top Leagues" && <TopLeagues />}
            </div>
          </>
        </div>
      </div>
    </Layout>
  );
}

export default SportsbookFM;
